export default __webpack_public_path__ + "static/dug-801509004798ab5caed52f5729225117.png";